module.exports = "<app-chips-basic [label]=\"labelSubjects\" \n[items]=\"subjectItems\" \n(notify)=\"setClickSubjectItem($event)\">\n</app-chips-basic>"